import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useClickOutside from "../../helpers/clickOutside";
import { useSelector } from "react-redux";
import {
  acceptRequest,
  addFriend,
  cancelRequest,
  deleteRequest,
  follow,
  unfollow,
  unfriend,
  blockUser,
  addToFavorites,
  removeFromFavorites,
} from "../../functions/user";

export default function Friendship({ friendshipp, profileid }) {
  const [friendship, setFriendship] = useState(friendshipp);
  const [blocked, setBlocked] = useState(false);
  const [isFavorite, setIsFavorite] = useState(friendshipp?.isFavorite || false);
  const navigate = useNavigate();

  useEffect(() => {
    setFriendship(friendshipp);
    setIsFavorite(friendshipp?.isFavorite || false);
  }, [friendshipp]);

  const [friendsMenu, setFriendsMenu] = useState(false);
  const [respondMenu, setRespondMenu] = useState(false);
  const [moreMenu, setMoreMenu] = useState(false);
  const menu = useRef(null);
  const menu1 = useRef(null);
  const menu2 = useRef(null);
  useClickOutside(menu, () => setFriendsMenu(false));
  useClickOutside(menu1, () => setRespondMenu(false));
  useClickOutside(menu2, () => setMoreMenu(false));
  const { user } = useSelector((state) => ({ ...state }));

  const addFriendHandler = async () => {
    setFriendship({ ...friendship, requestSent: true, following: true });
    await addFriend(profileid, user.token);
  };
  const cancelRequestHandler = async () => {
    setFriendship({ ...friendship, requestSent: false, following: false });
    await cancelRequest(profileid, user.token);
  };
  const followHandler = async () => {
    setFriendship({ ...friendship, following: true });
    await follow(profileid, user.token);
  };
  const unfollowHandler = async () => {
    setFriendship({ ...friendship, following: false });
    await unfollow(profileid, user.token);
  };
  const acceptRequestHanlder = async () => {
    console.log("Attempting to accept friend request from:", profileid);
    const result = await acceptRequest(profileid, user.token);
    console.log("Accept request result:", result);
    
    if (result === "ok") {
      setFriendship({
        ...friendship,
        friends: true,
        following: true,
        requestSent: false,
        requestReceived: false,
      });
    } else {
      // Show error to user
      alert(`Erro ao aceitar pedido: ${result}`);
      console.error("Failed to accept request:", result);
    }
  };
  const unfriendHandler = async () => {
    setFriendship({
      ...friendship,
      friends: false,
      following: false,
      requestSent: false,
      requestReceived: false,
    });
    setIsFavorite(false);
    await unfriend(profileid, user.token);
  };
  const deleteRequestHanlder = async () => {
    setFriendship({
      ...friendship,
      friends: false,
      following: false,
      requestSent: false,
      requestReceived: false,
    });
    await deleteRequest(profileid, user.token);
  };
  const blockHandler = async () => {
    const res = await blockUser(profileid, user.token);
    if (res === "ok") {
      setBlocked(true);
      setFriendship({
        friends: false,
        following: false,
        requestSent: false,
        requestReceived: false,
      });
      setMoreMenu(false);
    }
  };
  const favoriteHandler = async () => {
    if (isFavorite) {
      const res = await removeFromFavorites(profileid, user.token);
      if (res === "ok") {
        setIsFavorite(false);
      }
    } else {
      const res = await addToFavorites(profileid, user.token);
      if (res === "ok") {
        setIsFavorite(true);
      }
    }
    setFriendsMenu(false);
  };

  if (blocked) {
    return (
      <div className="friendship">
        <div className="gray_btn" style={{ cursor: "default" }}>
          <span>User Blocked</span>
        </div>
      </div>
    );
  }

  return (
    <div className="friendship">
      {friendship?.friends ? (
        <div className="friends_menu_wrap">
          <button className="gray_btn" onClick={() => setFriendsMenu(true)}>
            <img src="../../../icons/friends.png" alt="" />
            <span>Friends</span>
            {isFavorite && <span style={{ marginLeft: "5px" }}>⭐</span>}
          </button>
          {friendsMenu && (
            <div className="open_cover_menu" ref={menu}>
              <div
                className="open_cover_menu_item hover1"
                onClick={favoriteHandler}
              >
                <img src="../../../icons/favoritesOutline.png" alt="" />
                {isFavorite ? "Remove from Favorites" : "Add to Favorites"}
              </div>
              <div className="open_cover_menu_item hover1">
                <img src="../../../icons/editFriends.png" alt="" />
                Edit Friend list
              </div>
              {friendship?.following ? (
                <div
                  className="open_cover_menu_item hover1"
                  onClick={() => unfollowHandler()}
                >
                  <img src="../../../icons/unfollowOutlined.png" alt="" />
                  Unfollow
                </div>
              ) : (
                <div
                  className="open_cover_menu_item hover1"
                  onClick={() => followHandler()}
                >
                  <img src="../../../icons/unfollowOutlined.png" alt="" />
                  Follow
                </div>
              )}
              <div
                className="open_cover_menu_item hover1"
                onClick={() => unfriendHandler()}
              >
                <i className="unfriend_outlined_icon"></i>
                Unfriend
              </div>
              <div
                className="open_cover_menu_item hover1"
                onClick={blockHandler}
                style={{ color: "#be4b49" }}
              >
                <i className="block_icon"></i>
                Block
              </div>
            </div>
          )}
        </div>
      ) : (
        !friendship?.requestSent &&
        !friendship?.requestReceived && (
          <button className="blue_btn" onClick={() => addFriendHandler()}>
            <img src="../../../icons/addFriend.png" alt="" className="invert" />
            <span>Add Friend</span>
          </button>
        )
      )}
      {friendship?.requestSent ? (
        <button className="blue_btn" onClick={() => cancelRequestHandler()}>
          <img
            src="../../../icons/cancelRequest.png"
            className="invert"
            alt=""
          />
          <span>Cancel Request</span>
        </button>
      ) : (
        friendship?.requestReceived && (
          <div className="friends_menu_wrap">
            <button className="gray_btn" onClick={() => setRespondMenu(true)}>
              <img src="../../../icons/friends.png" alt="" />
              <span>Respond</span>
            </button>
            {respondMenu && (
              <div className="open_cover_menu" ref={menu1}>
                <div
                  className="open_cover_menu_item hover1"
                  onClick={() => acceptRequestHanlder()}
                >
                  Confirm
                </div>
                <div
                  className="open_cover_menu_item hover1"
                  onClick={() => deleteRequestHanlder()}
                >
                  Delete
                </div>
              </div>
            )}
          </div>
        )
      )}
      <div className="flex">
        {friendship?.following ? (
          <button className="gray_btn" onClick={() => unfollowHandler()}>
            <img src="../../../icons/follow.png" alt="" />
            <span>Following</span>
          </button>
        ) : (
          <button className="blue_btn" onClick={() => followHandler()}>
            <img src="../../../icons/follow.png" className="invert" alt="" />
            <span>Follow</span>
          </button>
        )}
        <button
          className={friendship?.friends ? "blue_btn" : "gray_btn"}
          onClick={() => navigate(`/chat/${profileid}`)}
        >
          <img
            src="../../../icons/message.png"
            className={friendship?.friends ? "invert" : undefined}
            alt=""
          />
          <span>Message</span>
        </button>
        {!friendship?.friends && (
          <div className="friends_menu_wrap" ref={menu2}>
            <button
              className="gray_btn"
              onClick={() => setMoreMenu(!moreMenu)}
              style={{ padding: "8px 12px" }}
            >
              <span>•••</span>
            </button>
            {moreMenu && (
              <div className="open_cover_menu">
                <div
                  className="open_cover_menu_item hover1"
                  onClick={blockHandler}
                  style={{ color: "#be4b49" }}
                >
                  <i className="block_icon"></i>
                  Block
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
